import styled from 'styled-components'

export default styled.div`
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.1);
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .map-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #f5f5f5;

    .spinner {
      width: 40px;
      height: 40px;
      border: 4px solid rgba(0, 0, 0, 0.1);
      border-top-color: ${({ $primaryColor }) => $primaryColor || '#FE7D11'};
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    p {
      margin-top: 1em;
      font-size: 0.9rem;
      color: #666;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    }
  }

  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    padding: 2em;
    text-align: center;

    .error-icon {
      font-size: 3rem;
      margin-bottom: 0.5em;
    }

    p {
      color: #666;
      font-size: 0.95rem;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    }
  }

  /* Leaflet map customization */
  .leaflet-container {
    width: 100%;
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  }

  .leaflet-popup-content-wrapper {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .leaflet-popup-content {
    margin: 8px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  }

  .leaflet-control-zoom {
    border: none;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .leaflet-control-zoom a {
    border: none;
    
    &:hover {
      background: ${({ $primaryColor }) => $primaryColor || '#FE7D11'};
      color: white;
    }
  }

  .leaflet-control-attribution {
    font-size: 10px;
    background: rgba(255, 255, 255, 0.8);
    padding: 2px 5px;
    
    a {
      color: ${({ $primaryColor }) => $primaryColor || '#FE7D11'};
    }
  }

  .map-legend {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 1.5em;
    padding: 0.8em 1.5em;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;

    @media (max-width: 600px) {
      flex-direction: column;
      gap: 0.5em;
      padding: 0.6em 1em;
      bottom: 10px;
    }

    .legend-item {
      display: flex;
      align-items: center;
      gap: 0.5em;
      font-size: 0.85rem;
      color: #333;

      .legend-marker {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        flex-shrink: 0;
      }
    }
  }
`
